export class GalleryModel {
  constructor(props) {
    this.id = props['id'];
    this.description =  props['description'];
    this.status = props['state']?'Publicado':'Error';
    this.linkPhoto =   props['linkPhoto'];
    this.date = props['dateCreated'];
  }
}